import React from 'react';
import { Button } from 'semantic-ui-react';
import ConvertDictionaryRowButton from './ConvertDictionaryRowButton';
import ValidateDictionaryRowButton from './ValidateDictionaryRowButton';

const DataManagementDictionaryButtonGroup = ({
  allowConversion,
  convert,
  dictionaryCode,
  dictionaryName,
  disableConvert,
  disableValidate,
  size = 'mini',
  validate,
}) => (
  <Button.Group basic size={size} icon compact>
    <ValidateDictionaryRowButton onClick={() => validate({ dictionaryCode })} disabled={disableValidate} />
    {allowConversion && (
      <ConvertDictionaryRowButton
        onClick={() => convert({ dictionaryCode, dictionaryName })}
        disabled={disableConvert}
      />
    )}
  </Button.Group>
);

export default DataManagementDictionaryButtonGroup;
